import React, {useEffect, useState} from 'react';

const CardQueue = () => {

    const [queue, setQueue] = useState(false);

    function timer(){
        setTimeout(() => {setQueue(true) }, 5000); 
    }

    useEffect(() => {
        timer()
    }, []);

    return(
        <div>
        {   
            !queue &&
            <div className="loader"></div>
        }
        {   
            queue &&
            <div className="loading-card-component">
                <div className="card-content">
                    <div className="loading-card-holder">

                        <div className="queue-title-holder">
                            <h3>You are in queue.<br/>Please, don’t refresh this window.</h3>
                        </div>
                        <div className="loader-holder">
                            <div className="card-loader"></div>
                        </div>          
                    </div>
                </div>
            </div>
        }
        </div>
    )

};

export default CardQueue;